<template>
  <div class="settings-header">
    <a href="#" class="settings-close" @click.prevent="goBack">
      <span><i class="icon-arrow-up"></i></span> Settings
    </a>
    <div class="settings-block">
      <div class="block">
        <strong class="title"><i class="icon-user"></i>My Account</strong>
        <ul class="sub-settings">
          <li><router-link to="/settings">Profile</router-link></li>
          <li><router-link to="/settings/billing">Billing</router-link></li>
          <li><router-link to="/settings/plans">Plans</router-link></li>
          <li>
            <router-link to="/settings/connected-apps"
              >Connected apps</router-link
            >
          </li>
        </ul>
      </div>
      <div class="block">
        <strong class="title"><i class="icon-briefcase"></i>Workspace</strong>
        <ul class="sub-settings">
          <li><router-link to="/settings/workspaces">General</router-link></li>
        </ul>
      </div>
      <div class="block">
        <strong class="title">
          <a @click="handleLogout" href="#"
            ><i class="icon-signout"></i>Sign Out</a
          >
        </strong>
      </div>
    </div>
  </div>
</template>

<script>
import { useWorkSpaceStore } from "@/stores/workspace-store";
import { mapStores } from "pinia";

export default {
  name: "SettingsNavigation",
  computed: {
    ...mapStores(useWorkSpaceStore),
  },
  methods: {
    goBack() {
      // Navigate directly to workspace-home instead of "/" to avoid
      // triggering the onboarding check in the home route guard
      const workspaceUUID = this.workspaceStore?.activeWorkspaceUUID;
      if (workspaceUUID) {
        this.$router.push({
          name: "workspace-home",
          params: { workspaceUUID },
        });
      } else {
        // Fallback to home if no workspace (shouldn't happen normally)
        this.$router.push({ name: "home" });
      }
    },
    handleLogout() {
      // Implement the logout logic here
      this.$auth0.logout();
    },
  },
};
</script>
